$("body").css("overflow", "hidden");
function hidePageLoad() {
  if ($("#page_load").is(":visible")) {
    $("#page_load").hide();
    $("body").css("overflow", "initial");
  }
}
let isFirstShowFestival = false;
const baseUrl =
  "https://cdd-static-upy.chediandian.com/actives_2020/05/icbcactivecar/img/";
const highDescPage = "./";
const strUrl = wlutils.parseQueryString(window.location.href);
export var vm = new Vue({
  components: { wlDialog, wlFormRow },
  el: "#app",
  data: {
    top: {
      topImg: baseUrl + "shop_banner@2x.png", //背景图片
      topBgColor: "#FFEBE1", //背景色
      topHeight: "2.85rem", //距离顶部位置
    },
    main: {
      top: {
        topImg: baseUrl + "shop_title@2x.png", //顶部图片
        gift: [baseUrl + "shop_ds@2x.png", baseUrl + "shop_hf@2x.png"], //礼包图片
        btnText: "添加爱车领礼包", //按钮文字
      },
    },
    tips: {
      tipsImg: baseUrl + "index_title2@2x.png",
      tipsHtml:
        '<p> 1、活动时间：2020年5月20日至2020年6月20日；<br>2、活动仅限中国银行信用卡用户参与，请使用中国银行信用卡预留手机号登录并参与活动；<br> 3、活动期间，新用户绑定爱车，即可免费获赠30元话费券和600元戴森券；<br> 4、同一用户仅可参与一次，限领1次奖品。同一手机账号、同一身份证、同一银行卡、同一终端设备号，均视为同一用户；<br> 5、礼品包含1张30元话费充值代金券和1张600元戴森券，代金券仅限中国银行信用卡使用，领取成功后，优惠券将在3个工作日内发送至聪明购账户，登录中国银行“聪明购”商城，即可查看使用<a href="https://auto.chediandian.com/institution/zh-owner/rule"> <b>（点击查看使用说明>>）</b> </a> ；<br> 6、话费券和戴森券使用期限为5月20日至7月20日，请在使用期限内使用；<br> 7、活动期间，如遇到短信验证码收不到的问题，可拨打<a href="tel:4006935000">400-693-5000</a>客服热线咨询处理。</p>',
    },
    layer: {
      result: {
        img: baseUrl + "success@2x.png",
        url:
          "https://jf365.boc.cn/BOCCMALL_M/jsp/h5Activity/CheZhuZhuanQu/index.html",
      },
      login: false,
    },
    form: {
      mobile: "",
      vcode: "",
    },
    user: {
      isLogin,
      token,
    },
    state: {
      result: false,
      isBindCar,
    },
  },
  // 生命周期
  created: function () {},
  mounted: function () {
    // 如果url地址带参数就显示结果页
    if (strUrl && strUrl.result && strUrl.result == "yes") {
      this.state.result = true;
      $(".layer_result__main p").html(
        "600元大礼包将在3个工作日发放到手机账户<br>可在中国银行“聪明购”商城查看"
      );
      this.main.top.btnText = "查看我的礼包";
    }
    if (this.user.isLogin && this.state.isBindCar) {
      this.main.top.btnText = "查看我的礼包";
    }
    wlutils.fixedInput("input");
    this.$nextTick(() => {
      this.appendVConsole();
      hidePageLoad();
      $("title").text("600元大礼包免费领");
    });
  },
  // 方法
  methods: {
    appendVConsole() {
      var str = wlutils.parseQueryString(window.location.href);
      if (!wlutils.isEmptyObject(str) && str.flag === "cdd_debug") {
        var scriptDom = document.createElement("script");
        scriptDom.src =
          "https://cdd-static-upy.chediandian.com/front/vconsole.min.js";
        document.body.appendChild(scriptDom);
        scriptDom.onload = () => {
          var vConsole = new VConsole();
        };
      }
    },
    postCode() {
      typeof getCodeCallback === "function" && getCodeCallback(this.$refs.code);
    },
    postCodeError() {
      showMsg("请输入合法的手机号");
    },
    handlerGive() {
      if (!this.user.isLogin) {
        this.layer.login = true;
        return;
      }
      if (this.state.isBindCar) {
        this.main.top.btnText = "查看我的礼包";
        this.state.result = true;
        $(".layer_result__main p").html(
          "600元大礼包将在3个工作日发放到手机账户<br>可在中国银行“聪明购”商城查看"
        );
        return;
      }
      showLoad("领取中");
      this._ajaxGive();
    },
    handleLogin() {
      if (!wlutils.isMobile(this.form.mobile)) {
        showMsg("请输入合法的手机号");
      } else if (!wlutils.isVCode(this.form.vcode)) {
        showMsg("请输入合法的验证码");
      } else {
        showLoad("登录中");
        typeof loginAjax === "function" && loginAjax(this.form);
      }
    },
    _ajaxGive() {
      // getGift
      let postData = postJson.getGift;
      postData.data.token = this.user.token;
      window.location.href = domain + "/institution/zh-owner/bind";
      // postData.data.
      // $("body").css("overflow", "hidden");
      // this.state.result  = true;
    },
  },
  // 计算
  computed: {},
  // 监控
  watch: {
    "layer.login": function (val) {
      if (val) {
        $("body").addClass("fixed");
      } else {
        $("body").removeClass("fixed");
      }
    },
  },
  // 过滤
  filters: {},
});

/**
展示弹窗
优先读取参数里的pic图片地址，如果不存在则读取变量festivalPic, 两个都没有则读取默认图片
*/
function showFestival(pic, clickFunc) {
  //是否结束展示
  if (typeof isStopFestival !== "undefined" && isStopFestival) {
    return false;
  }
  if (!pic && typeof festivalPic !== "undefined" && festivalPic.length > 0) {
    pic = festivalPic;
  }
  if (!pic || pic.length == 0) {
    pic = map();
  }
  var pic =
    pic ||
    "https://cdd-file-upy.chediandian.com/banner/20200102155608335004.png?v=1.0";

  $("body").append(
    '<div class="layer1_wrap"><div ontouchmover="return false" class="layer1_bg"></div><div class="layer1_box"><div class="layer1_child"><div class="layer1_main layer1_anim"><div class="layer1_main__img"><img src="' +
      pic +
      '"></div></div></div></div></div></div>'
  );
  $("head").append(
    "<style>.layer1_wrap{position:fixed;top:0;left:0;z-index:19860117;display:none;width:100%;height:100%}.layer1_bg,.layer1_box{position:fixed;top:0;left:0;z-index:19860118;width:100%;height:100%;cursor:pointer;}.layer1_bg{background-color:rgba(0,0,0,.5);pointer-events:auto}.layer1_box{border-radius:6px;z-index:19860119;display:table;pointer-events:none}.layer1_child{display:table-cell;vertical-align:middle;text-align:center}.layer1_main{position:relative;display:inline-block;padding:0;width:300px;max-width:640px;border-radius:6px;// background-color:#fff;text-align:center;font-size:18px;pointer-events:auto;-webkit-overflow-scrolling:touch;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-duration:.2s;animation-duration:.2s}.layer1_main__img{border-radius:10px;overflow:hidden;display:block;width:100%}.layer1_main__img img{display:block;margin:0 auto;width:100%;height:auto}.layer1_anim{animation-name:layui-m-anim-scale;-webkit-animation-name:layui-m-anim-scale}@-webkit-keyframes layui-m-anim-scale{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}@keyframes layui-m-anim-scale{0%{opacity:0;-webkit-transform:scale(.5);transform:scale(.5)}100%{opacity:1;-webkit-transform:scale(1);transform:scale(1)}}</style>"
  );
  if (isFirstShowFestival) {
    $(".layer1_wrap").show();
    if (!clickFunc) {
      $(document).on("click", ".layer1_bg,.layer1_box", function () {
        $(".layer1_wrap").hide();
      });
    }
  }
  if (clickFunc) {
    clickFunc();
  }
  isFirstShowFestival = false;
}
